import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentService } from '../../../../core/services/payment.service';
import { KioskSmsOrder, SavedOrder } from '../../../../core/models/payment-item.model';
import { RestaurantStore } from '../../../../core/stores/restaurant.store';
import { PaymentStore } from '../../../../core/stores/payment.store';
import { MenuItem, MenuItemData, MenuItemForPayment, MenuItemVariation } from '../../../../core/models/cart-item.model';
import { Price, Restaurant } from '../../../../core/models/restaurant.model';
import { CartStore } from '../../../../core/stores/cart.store';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderApiService } from '../../../../core/services/order.api.service';

@Component({
  selector: 'app-sms-transaction',
  templateUrl: './sms-transaction.component.html',
  styleUrls: ['./sms-transaction.component.scss'],
})
export class SmsTransactionComponent implements OnInit {
  @Input() public restaurant: Restaurant = new Restaurant();
  @Output() public isLoadedOrder: EventEmitter<SavedOrder> = new EventEmitter();
  private locationId: string;
  private merchantId: string;
  private transactionId: string;

  constructor(
    private paymentService: PaymentService,
    private restaurantStore: RestaurantStore,
    private paymentStore: PaymentStore,
    private cartStore: CartStore,
    private orderApiService: OrderApiService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.routerSubscription();
    this.getTransaction();
  }

  private getTransaction(): void {
    this.paymentService.getTransactionById(this.transactionId)
      .subscribe((data: any) => {
        const {square_order, square_location_id, square_merchant_id, fulfillment_type, is_asap, pickup_at, table_number} = data;
        this.isLoadedOrder.emit(new SavedOrder(true, square_location_id, square_merchant_id));
        this.restaurantStore.kioskSmsOrderData = new KioskSmsOrder(square_order.id, fulfillment_type, square_order.line_items, is_asap, new Date(pickup_at), table_number, square_order);
        // this.restaurantStore.bootstrapRestaurants(square_merchant_id);
        this.locationId = square_location_id;
        this.merchantId = data.platform_merchant_id;
        this.addAllTransactionItemsToCart();
      });
  }

  private addAllTransactionItemsToCart(): void {
    this.restaurantStore.kioskSmsOrderData.lineItems.map( (lineItem: any) => {
      if (lineItem.name !== 'Kyoo Service Charge' && lineItem.name !== 'Delivery fee') {
        let itemId = '';
        for (const products of this.restaurantStore.curProducts) {
          for (const product of products) {
            if (product.variations.find((variation) => variation.id === lineItem.catalog_object_id)) {
              itemId = product.info.id;
            }
          }
        }
        const item = new MenuItemForPayment(this.locationId, null, itemId, null);
        item.item = new MenuItemData(lineItem.catalog_object_id, lineItem.name, null, Number(lineItem.quantity),
          new MenuItemVariation(lineItem.variation_name, lineItem.catalog_object_id, new Price(lineItem.variation_total_price_money.amount, lineItem.variation_total_price_money.currency)),
          lineItem.modifiers ? lineItem.modifiers.map((modifier: any) => new MenuItem(modifier.name, modifier.catalog_object_id, new Price(modifier.total_price_money.amount, modifier.total_price_money.currency))) : [],
          null, new Price(lineItem.total_money.amount, lineItem.total_money.currency));
        this.cartStore.addItemToCart(item);
      }
    }).filter( (item) => item != null);
    const order = this.orderApiService.createOrder(this.locationId);
    const {id, total_money, discounts, taxes} = this.restaurantStore.kioskSmsOrderData.squareOrder;
    const amount = total_money.amount - this.cartStore.taxesSum(taxes);
    this.cartStore.orderMap[this.locationId] = {id, order, amount, discounts, taxes, loyaltyPoints: 0, isUpdated: false, isSubmitted: false, isPaid: false};
    // localStorage.setItem('mode', Mode.mobile); TODO: uncomment or remove if need mobile
  }

  private routerSubscription(): void {
    this.activeRoute.params.subscribe(params => {
      this.transactionId = params.transactionId;
    });
  }
}
